export default "__VITE_ASSET__nGtqVt_g__"